export default __webpack_public_path__ + "static/media/Going For Bullseye.b85d09ba.png";